import * as React from 'react';

const Publish = (props:any) => (
    <svg width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path fill="none" d="M0 0h32v32H0z" />
        <path
            d="M25.8 13.387c-.907-4.6-4.947-8.054-9.8-8.054a9.994 9.994 0 0 0-8.867 5.387A7.992 7.992 0 0 0 0 18.667c0 4.413 3.587 8 8 8h17.333A6.67 6.67 0 0 0 32 20c0-3.52-2.733-6.373-6.2-6.613zm-7.133 3.946v5.334h-5.334v-5.334h-4L16 10.667l6.667 6.666h-4z" />
    </svg>
);

export default Publish;

